import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import enCommon from './Localization/en/common.json';
import enCountries from './Localization/en/countries.json';
import ruCommon from './Localization/ru/common.json';
import ruCountries from './Localization/ru/countries.json';
import lvCommon from './Localization/lv/common.json';
import lvCountries from './Localization/lv/countries.json';

const el = document.getElementById('limmud-donations-form');

i18n.use(initReactI18next).init({
    compatibilityJSON: 'v3',
    lng: el.getAttribute("data-lang"),
    fallbackLng: 'en',
    resources: {
        en: {
            common: enCommon,
            countries: enCountries,
        },
        ru: {
            common: ruCommon,
            countries: ruCountries,
        },
        lv: {
            common: lvCommon,
            countries: lvCountries,
        },
    },
});
export default i18n;
